import { render, staticRenderFns } from "./NotAuthtorizationPage.vue?vue&type=template&id=352b31a3&scoped=true&"
var script = {}
import style0 from "./NotAuthtorizationPage.vue?vue&type=style&index=0&id=352b31a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b31a3",
  null
  
)

export default component.exports